import TagManager from 'react-gtm-module';
import { strippedContent } from '../lib/helpers';

const mediatype = (mediaType) =>
  mediaType === 'VIDEO' ? 'video' : mediaType === 'FOTO' ? 'image' : 'other';

const wordCount = (string) => {
  const splitString = string.split(' ');
  return splitString.length && splitString[0].length > 0 ? splitString.length : 0;
};

const postType = (nsfa, nsfw) => {
  if (nsfa && nsfw) {
    return 'NSFW&NSFA';
  } else if (nsfa && !nsfw) {
    return 'NSFA';
  } else if (!nsfa && nsfw) {
    return 'NSFW';
  }
  return '';
};

const parseVideoDuration = (value) => {
  switch (typeof value) {
    case 'number':
      return value;
    case 'string':
      return value
        .split(':')
        .reverse()
        .map((k) => parseInt(k))
        .reduce((a, b, i) => a + b * Math.pow(60, i));
  }
};

const numOfMediaType = (media, type) => (media || []).filter((x) => x.mediatype === type).length;

export const pushToDataLayer = (
  item,
  userLoggedin = false,
  isItemDetail = false,
  consentStatus,
) => {
  const dataLayer = {
    page_title: item.title,
    page_location: window.location.origin,
    page_location_full: window.location.href,
    identityaccountid: sessionStorage.getItem('sessionid'),
    subscriptionstatus: false,
    subscriptiontype: '',
    consent_status: consentStatus && consentStatus.length > 0 ? 'rejected' : 'accepted',
    c4: '',
    c7: encodeURIComponent(window.location),
    ns_site: 'total',
    nmo_02: !isItemDetail ? 1 : 0,
    nmo_05: 0,
    nmo_10: userLoggedin ? 1 : 0,
  };

  if (isItemDetail) {
    const itemDetailLayer = {
      post_type_name: postType(item.nopreroll, item.nsfw),
      access_walltype: userLoggedin ? 'logged-in' : 'logged-out',
      page_secure: item.nsfw,
      content_id: item.id,
      content_type: mediatype(item.media[0].mediatype),
      content_premium: false,
      content_publisher_source: 'Dumpert',
      content_taglist: item.tags,
      content_taglistparents: '',
      content_publication: item.date,
      content_author: 'Dumpert',
      content_word_count: wordCount(item.title + item.description),
      content_char_count: strippedContent(item.title + item.description).length,
      content_image_count: numOfMediaType(item.media, 'FOTO'),
      content_video_count: numOfMediaType(item.media, 'VIDEO'),
      content_layout: `Video(${numOfMediaType(item.media, 'VIDEO')})|Image(${numOfMediaType(item.media, 'FOTO')})|title|description|date|tags`,
    };

    Object.assign(dataLayer, itemDetailLayer);

    const isVideoItem = (item.media || []).some((x) => x.mediatype === 'VIDEO');

    if (isItemDetail && isVideoItem) {
      Object.assign(dataLayer, {
        nmo_30: 1,
        nmo_31: 0,
        nmo_32: parseVideoDuration((item.media || [{}])[0].duration),
      });
    }
  }

  return TagManager.dataLayer({ dataLayer });
};
